// Tokens identify selectable entries; numeric IDs identify durable POS data scopes.
const positiveId = value => Number.isSafeInteger(Number(value)) && Number(value) > 0;
export function hasPosContext(state) {
  return positiveId(state.user?.id) && positiveId(state.context?.company?.id)
    && (!state.context.branch || positiveId(state.context.branch.id));
}
